export const SSR_MODE = 'ssr';
export const EXPORT_MODE = 'export';
export const DOWNGRADE_MODE = 'download';
export const OFFLINE_MODE = 'offline';

export const FIREBASE_ENDPOINT_NAME = 'firebase';
export const SA_ENDPOINT_NAME = 'sa';
export const PROMETHEUS_ENDPOINT_NAME = 'prometheus';

export const PROMETHEUS_ENDPOINT_DOMAIN = {
  local: 'https://test-r.akulaku.net',
  dev: 'https://test-r.akulaku.net',
  test: 'https://test-r.akulaku.net',
  prod: 'https://r.akulaku.net',
}

export const PROMETHEUS_ENDPOINT_PATH = '/performance/web';

export const ATTRIBUTES_KEYS_BY_TYPE = {
  [FIREBASE_ENDPOINT_NAME]: {
    action: ['device_level'],
    network_api: ['pathname', 'no_response_data', 'protocol', 'is_https', 'no_download'],
    frame: ['device_level'],
    network_navigation: ['navigation_type', 'pathname', 'protocol', 'is_https', 'no_download'],
    page_perf: ['mode', 'device_level', 'need_net_resource', 'is_route_change', 'is_first_page'],
  },
  [PROMETHEUS_ENDPOINT_NAME]: {
    action: ['device_level'],
    network_api: ['pathname', 'api_type', 'no_response_data'],
    frame: ['device_level'],
    network_navigation: ['navigation_type'],
    page_perf: ['mode', 'device_level', 'need_net_resource', 'is_route_change'],
  },
};

export const UNKNOWN = 'UNKNOWN';
